import $ from "jquery";

$(function () {
  initClickOnCategory()
});

export const initClickOnCategory = () => {

  const $postCardEl = $(".post-card");
  const $postCardMainEl = $(".post-card-main");

  if ($postCardEl.length > 0) {
    $postCardEl.on("click", '.post-card__category', function (e) {
      e.preventDefault();
      const $thisEl = $(this);
      let link = $thisEl.data("link");
      let id = $thisEl.data("id");
      window.location.href = link + "?plSpc=" + id;
    });
  }
  if ($postCardMainEl.length > 0) {
    $postCardMainEl.on("click", '.post-card-main__category', function (e) {
      e.preventDefault();
      const $thisEl = $(this);
      let link = $thisEl.data("link");
      let id = $thisEl.data("id");
      window.location.href = link + "?plSpc=" + id;
    });
  }
};